import { createFileRoute } from '@tanstack/react-router';

import { Sam3PlaygroundView } from 'src/sections/admin/sam3-playground/sam3-playground-view';

export const Route = createFileRoute('/admin-skidog/sam3-playground')({
  component: Sam3PlaygroundView,
});
